import { GENERICS_HTTP_STATUS_CODES_MAPPER, HttpStatusMapper } from '@repo/core'
import { externalPageDataActions, externalToolLinkDataActions } from '../../slices'

export const httpStatusErrorCodesMapper: HttpStatusMapper = {
  GENERICS: GENERICS_HTTP_STATUS_CODES_MAPPER,
  [externalToolLinkDataActions.getResponse.type]: Object.keys(
    GENERICS_HTTP_STATUS_CODES_MAPPER,
  ).reduce(
    (customHttpStatusErrorCodesMapper, key) => {
      return {
        ...customHttpStatusErrorCodesMapper,
        [key]: 'EXTERNAL_TOOL_LINK_GENRIC_BLOCKER_ERROR',
      }
    },
    {} as Record<string, string>,
  ),
  [externalPageDataActions.getResponse.type]: Object.keys(GENERICS_HTTP_STATUS_CODES_MAPPER).reduce(
    (customHttpStatusErrorCodesMapper, key) => {
      return {
        ...customHttpStatusErrorCodesMapper,
        [key]: 'EXTERNAL_PAGE_GENRIC_BLOCKER_ERROR',
      }
    },
    {} as Record<string, string>,
  ),
}
